import { AnagraficaApi, ApiAnagraficaNdgAddGetRequest, ClienteDto, Configuration, DatiAnagraficiCedacriDto, ErrorEnumType, ErrorResponseDto } from '@desio/api';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'store';
import getConfiguration, { decodeError, errorHandler } from 'store/config';

export const getRicercaNdgCedacri = createAsyncThunk<DatiAnagraficiCedacriDto | undefined, void, ThunkApiConfig>(
  'anagrafica/getRicercaNdgCedacri', async (_, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/get-ricerca-ndg.json')).default;
      } else {
        return await new AnagraficaApi(getConfiguration(Configuration, extra, getState)).apiAnagraficaNdgRicercaGet({ ndg: parseInt(getState().ricercaAnagrafe.ndg) });
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const setNdgAction = createAction<string, 'setNdgAction'>('setNdgAction');
export const resetNdg = createAction<undefined, 'resetNdg'>('resetNdg');

export const addAnagraficaCedacri = createAsyncThunk<ClienteDto | undefined, boolean, ThunkApiConfig>(
  'anagrafica/addAnagraficaCedacri', async (forceInsert, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/add-anagrafica-cedacri.json')).default;
      } else {
        const cliente = getState().ricercaAnagrafe.clienteRicercato;
        if (cliente) {
          const request: ApiAnagraficaNdgAddGetRequest = {
            ndg: cliente.ndg!,
            forceInsert: forceInsert || false
          }
          return await new AnagraficaApi(getConfiguration(Configuration, extra, getState)).apiAnagraficaNdgAddGet(request);
        }
      }
    } catch (error) {
      const errorResponse = await decodeError(error);
      if (errorResponse.errorType === ErrorEnumType.NUMBER_2) {
        dispatch(erroreAddAnagraficaCedacriAction(errorResponse));
      } else {
        errorHandler(errorResponse, dispatch, true);
      }
    }
  }
);

export const erroreAddAnagraficaCedacriAction = createAction<ErrorResponseDto, 'erroreAddAnagraficaCedacri'>('erroreAddAnagraficaCedacri');
export const resetErroreAddAnagraficaCedacriAction = createAction<void, 'resetErroreAddAnagraficaCedacriAction'>('resetErroreAddAnagraficaCedacriAction');

export const resetClienteSelezionatoAction = createAction<void, 'resetClienteSelezionatoAction'>('resetClienteSelezionatoAction');
export const resetClienteRicercatoAction = createAction<void, 'resetClienteRicercatoAction'>('resetClienteRicercatoAction');
